import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import WireResultsContext from './context';
import Keywords from '../common/components/keywords';
import useGetKeywordsFromWires from '../../../services/keywords/from-wires-service';

export default function TopKeywords({ titleMatchedWires }) {
  const { dispatch } = React.useContext(WireResultsContext);
  const wireIDs = _.map(titleMatchedWires, 'id');
  const [{ data }, executeQuery] = useGetKeywordsFromWires(wireIDs, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'keywords.length')) {
      dispatch({ type: 'setKeywords', payload: data.keywords });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'keywords.length')) {
    return null;
  }

  const props = { data, relation: 'assigned to', query: titleMatchedWires[0].title };
  return <Keywords {...props} />;
}

TopKeywords.propTypes = {
  titleMatchedWires: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
};
